import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import * as Sentry from '@sentry/react';

import { MAIN_URL } from 'constants/api-constants';

const baseQuery = fetchBaseQuery({
  baseUrl: MAIN_URL,
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'text/plain;application/json;');

    return headers;
  },
});

const baseQueryWithSentry: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    Sentry.captureException(JSON.stringify(result.error));
    result = await baseQuery(args, api, extraOptions);
  }

  return result;
};

export const ecomApi = createApi({
  reducerPath: 'ecomApi',
  baseQuery: baseQueryWithSentry,
  tagTypes: ['Payment'],
  endpoints: () => ({}),
});

export const enhancedApi = ecomApi.enhanceEndpoints({
  endpoints: () => ({}),
});
